import { matchPath, Redirect, Route, Switch, useLocation } from "react-router-dom";
import { ROUTES } from "../App";
import {
  ROUTE_ABOUT_US,
  ROUTE_CART,
  ROUTE_EXTRA_PAGE,
  ROUTE_NOT_FOUND,
  ROUTE_PAGE_HOME, ROUTE_PAGE_LOGIN,
  ROUTE_PAGE_TEST,
  ROUTE_PRODUCT_LIST,
  ROUTE_SHIPPING_WAYS,
  ROUTE_SINGLE_PRODUCT,
  ROUTE_THANK_YOU,
} from "./routes";

import NotFound from "../pages/notFound/notFound.jsx";

const PUBLIC_ROUTES = [
  ROUTE_PAGE_HOME,
  ROUTE_PAGE_TEST,
  ROUTE_PRODUCT_LIST,
  ROUTE_SINGLE_PRODUCT,
  ROUTE_CART,
  ROUTE_ABOUT_US,
  ROUTE_EXTRA_PAGE,
  ROUTE_SHIPPING_WAYS,
  ROUTE_THANK_YOU,
  ROUTE_NOT_FOUND,
];

const UnauthenticatedRouter = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const matchingPrivate = ROUTES && ROUTES.some((route) => {
    if (!route || !route.path) return false;
    if (!route.private) return false;
    const match = matchPath(pathname, { path: route.path, exact: !!route.exact, strict: false });
    return Boolean(match);
  });

  if (matchingPrivate) {
    return <Redirect to="/not-found" />;
  }

  return (
    <Switch>
      {PUBLIC_ROUTES.map((route) => {
        const { key, path, exact, component } = route;
        return <Route key={key} path={path} exact={exact} component={component} />;
      })}

      <Route exact path="/not-found" component={NotFound} />

      <Route component={NotFound} />
    </Switch>
  );
};

export default UnauthenticatedRouter;
